import usersAPI from '@/services/API/user'

//Fetch customer based on a search string
const fetchAdminUsers = function({ commit, state }) {
  if(state.adminUsersOutDated){
    return usersAPI.listAdminUserV2().then(fetchedAdminUsers => {
      commit('SET_ADMIN_USERS', fetchedAdminUsers);
    });
  }
};

const invalidateAdminUser = function({commit}) {
  commit('INVALIDATE');
}

export default {
  fetchAdminUsers,
  invalidateAdminUser
};
